import Row from 'reactstrap/es/Row';
import Col from 'reactstrap/es/Col';
import Button from 'reactstrap/es/Button';
import ButtonGroup from 'reactstrap/es/ButtonGroup';
import { useState } from 'react';
import classNames from 'classnames';
import { endOfDay, startOfDay } from 'date-fns';
import { pick } from 'lodash';
import { Overview } from './overview';
import { PopularProducts } from './popularProducts';
import { BestMedia } from './bestMedia';
import { BestPromocodes } from './bestPromocodes';
import { ButtonDatePicker } from '../buttonDatePicker';
import { usePreconfiguredPeriods } from './usePreconfiguredPeriods';

export function GeneralPage () {
	const [periodIndex, setPeriodIndex] = useState(0);
	const [customDates, setCustomDates] = useState([]);
	const [promocodeViewType, setPromocodeViewType] = useState('media');
	const preconfiguredPeriods = usePreconfiguredPeriods();

	const dates = periodIndex === -1 ? { start: startOfDay(customDates[0]), end: endOfDay(customDates[1]) } : pick(preconfiguredPeriods[periodIndex], ['start', 'end']);

	return (
		<>
			<div className="header-analytics center">
				<ButtonGroup>
					{preconfiguredPeriods.map((periodProps, index) => (
						<Button
							color={periodIndex === index ? 'dark' : 'secondary'}
							className={classNames({ active: periodIndex === index })}
							onClick={() => setPeriodIndex(index)}
						>{periodProps.name}
						</Button>
					))}
					<ButtonDatePicker
						isActive={periodIndex === -1}
						onChange={(values) => {
							setCustomDates(values);
							setPeriodIndex(-1);
						}}
					/>
				</ButtonGroup>
			</div>
			<hr />
			<Overview from={dates.start} to={dates.end} />
			<Row>
				<Col lg={12}>
					<PopularProducts from={dates.start} to={dates.end} />
					<br />
					<br />
				</Col>
				{/* <Col lg={12}>
					<div className="header-analytics ">
						<ButtonGroup>
							<Button
								color={promocodeViewType === 'media' ? 'dark' : 'secondary'}
								disabled={promocodeViewType === 'media'}
								onClick={() => setPromocodeViewType('media')}
							>Пользователи и инфлюенсеры
							</Button>
							<Button
								color={promocodeViewType === 'promocode' ? 'dark' : 'secondary'}
								disabled={promocodeViewType === 'promocode'}
								onClick={() => setPromocodeViewType('promocode')}
							>Промокоды
							</Button>
						</ButtonGroup>
					</div>
					{promocodeViewType === 'media' && (
						<BestMedia from={dates.start} to={dates.end} />
					)}
					{promocodeViewType === 'promocode' && (
						<BestPromocodes from={dates.start} to={dates.end} />
					)}
				</Col> */}
			</Row>
		</>
	);
}
